import NewButton from 'CMFW/button/NewButton';
import ReloadButton from 'CMFW/button/ReloadButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import { ContainerLeft, ContainerLeftFooter, ContainerRight, ModuleContainer } from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import Note from 'modules/Note/Note';
import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { ItemTabs } from '../../CMFW/layout/ItemTabs';
import TextSearch from '../../components/search/TextSearch';
import TrainerModel from '../../models/TrainerModel';
import TrainerEdit from './tabs/TrainerEdit';
import TrainerSegment from './tabs/TrainerSegment';
import Button from '@material-ui/core/Button';

import { INavigationStep } from 'types/navigation';
import { IRefIds } from 'constants/refs';

export type IProps = {
  courseId: number;
  search?: string;
  navigationPath?: INavigationStep[];
};

const Trainer: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();
  const [showTabIndex, setShowTabIndex] = useState<number | undefined>();
  const [trainerSegmentId, setTrainerSegmentId] = useState<number>(0);

  const trainerModel = useMemo(
    () => new TrainerModel({ render: forceRender, courseId: props.courseId, search: props.search }),
    [forceRender, props.courseId, props.search],
  );

  // Process navigation path only once
  useEffect(() => {
    if (props.navigationPath && props.navigationPath.length > 0) {
      const firstStep = props.navigationPath[0];
      // Check if navigating to TrainerSegment
      if (firstStep.ref === IRefIds.trainerSegment) {
        setShowTabIndex(1); // Switch to Segments tab
        setTrainerSegmentId(firstStep.refId); // Set the segment ID to load
      }
    }
  }, [props.navigationPath]);

  const resetTrainerSegmentId = useCallback(() => {
    setTrainerSegmentId(0);
  }, []);

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={trainerModel}>
        <Split widthLeft={500}>
          <ContainerLeft>
            <TextSearch />
            <Grid
              cellRenderers={{
              }}

              onRowClick={resetTrainerSegmentId}
            />
            <ContainerLeftFooter>
              <ReloadButton />
              <Button variant="outlined" size="small" onClick={trainerModel.checkTrainers.bind(trainerModel)}>
                check
              </Button>
              <NewButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <ItemTabs tabNames={['Edit', 'Segments']} showTabIndex={showTabIndex}>
                <TrainerEdit key={'Edit' + trainerModel.itemId} />
                <TrainerSegment key={'Segments' + trainerModel.itemId} trainerSegmentId={trainerSegmentId} />
              </ItemTabs>
            </ItemLayout>
            <Note />
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

export default Trainer;
